<template>
  <footer class="footer">
    <div class="container text-center py-4">
      <img src="/img/logo_footer.png" alt="Logo Footer" width="189" height="136">
      <div class="copyright mt-4">
        <p><strong>© 2018 Sara Schenirer Institute. All Rights Reserved.</strong></p>
        <span id="back_to_top" @click.prevent="backToTop()">
          <fa icon="angle-up"/>
        </span>
        <p class="font-italic font-weight-light">
          Sara Schenirer is not a college or university and does not offer credit bearing courses or degrees in New York State.
          <br>
          Any credit or degrees described here are offered through our partner institutions.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'StickyFooter',

  methods: {
    backToTop () {
      $('html,body').animate({
        scrollTop: 0
      }, 700)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/StickyFooter.vue